import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { AssetImage } from "./AssetImage";
import { ASSETS, GALLERY } from "../../config/site";

export const Gallery = () => (
  <Section
    id="gallery"
    className="bg-sand/50"
    overline="Gallery"
    title="The estate, in frames"
    sub="Renders and photographs from the estate — replaced with fresh site photography as construction progresses."
  >
    <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
      {GALLERY.map((g, i) => (
        <Reveal key={g.key} delay={(i % 4) * 0.06}>
          <figure className="group relative overflow-hidden border border-border" data-testid={`gallery-${g.key}`}>
            <AssetImage
              asset={ASSETS[g.key]}
              alt={g.label}
              className="aspect-[4/3] w-full object-cover transition-transform duration-500 group-hover:scale-105"
              placeholderLabel={g.label}
            />
            <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-forest-dark/80 to-transparent px-3 pb-2.5 pt-8 text-xs font-medium text-paper">
              {g.label}
            </figcaption>
          </figure>
        </Reveal>
      ))}
    </div>
  </Section>
);
